import { Outlet } from 'react-router';

export default function RegisterLayout() {
  return <Outlet />;
}
